<div class="tp-wrapper">
  <div class="tp-picker">
    <button class="tp-btn" (click)="incrementHour()">
      <i class="pi pi-chevron-up tp-icon"></i>
    </button>
    <input
      class="tp-input"
      [value]="hourText"
      (input)="onInputText($event, 'hour')"
      (blur)="onBlur('hour')"
      (click)="selectAll($event)"
    />
    <button class="tp-btn" (click)="decrementHour()">
      <i class="pi pi-chevron-down tp-icon"></i>
    </button>
  </div>
  <div class="tp-separator">:</div>

  <div class="tp-picker">
    <button class="tp-btn" (click)="incrementMinute()">
      <i class="pi pi-chevron-up tp-icon"></i>
    </button>
    <input
      class="tp-input"
      [value]="minuteText"
      (input)="onInputText($event, 'minute')"
      (blur)="onBlur('minute')"
      (click)="selectAll($event)"
    />
    <button class="tp-btn" (click)="decrementMinute()">
      <i class="pi pi-chevron-down tp-icon"></i>
    </button>
  </div>

  <ng-container *ngIf="showSeconds">
    <div class="tp-separator">:</div>
    <div class="tp-picker">
      <button class="tp-btn" (click)="incrementSecond()">
        <i class="pi pi-chevron-up tp-icon"></i>
      </button>
      <input
        class="tp-input"
        [value]="secondText"
        (input)="onInputText($event, 'second')"
        (blur)="onBlur('second')"
        (click)="selectAll($event)"
      />
      <button class="tp-btn" (click)="decrementSecond()">
        <i class="pi pi-chevron-down tp-icon"></i>
      </button>
    </div>
  </ng-container>
</div>
